<template>
  <div v-if="!complete">
    <next-button @click="openAddressModal" :text="'Add an Address'" />
    <current-address-form-modal
      v-if="modalOpen"
      @close="closeAddressModal"
      @success="emit('success', $event)"
      :applicant="applicant"
      :stipulation="stip"
    />
  </div>
</template>
<script setup lang="ts">
import { useStore } from "vuex";
import { computed } from "vue";
import { StipulationStatusIds } from "@/config/constants";
import type { Applicant } from "@/models/application";
import type { Stipulation } from "@/models/opal";
import NextButton from "@/components/shared/NextButton.vue";
import CurrentAddressFormModal from "@/components/modals/CurrentAddressFormModal.vue";

const store = useStore();

interface Props {
  stip: Stipulation;
  applicant: Applicant;
}

const props = withDefaults(defineProps<Props>(), {});

const emit = defineEmits<{
  (e: "success", updatedStip: Stipulation): void;
}>();

const complete = computed(
  () =>
    props.stip.stipulationStatusId === StipulationStatusIds.COMPLETED ||
    props.stip.stipulationStatusId === StipulationStatusIds.CU_OVERRIDE,
);

const modalOpen = computed(() => store.state.modal.currentAddressModalActive);

function openAddressModal() {
  store.state.forms.currentAddressForm.applicantId = props.applicant?.id;
  store.state.forms.currentAddressForm.stipulationId = props.stip?.id;
  store.dispatch("forms/setCurrentAddressForm", store.state.forms.currentAddressForm);
  store.dispatch("modal/openCurrentAddressModal");
}

function closeAddressModal() {
  store.dispatch("modal/closeCurrentAddressModal");
}
</script>
